//
// MediaTarget.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./BIRDModel";
import "./media/MediaScheme";
import "../util/mediaTarget/WindowSize";

var MediaTarget = createModule("BIRD::MediaTarget", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        windowSize: 4,
        scheme: 1,
        name: 7,
        definition: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MediaTarget;
